import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import { useSeo } from '@/seo/useSeo';

export function NotFound(): JSX.Element {
  useSeo({
    title: 'Page not found',
    description: 'The page you were looking for doesn’t exist.',
    path: '/404',
    noindex: true,
  });
  return (
    <section className="py-24 text-center md:py-32">
      <div className="container-content">
        <p className="text-xs font-bold uppercase tracking-[0.14em] text-nexus-purple-light">404</p>
        <h1 className="mt-3 font-display text-3xl font-bold text-nexus-ink md:text-4xl">
          That page doesn&apos;t exist.
        </h1>
        <p className="mx-auto mt-4 max-w-md text-white/65">
          It may have moved, or the link was mistyped. Head back to the homepage or browse the
          platform, roadmap, and blog from the navigation above.
        </p>
        <Button component={Link} to="/" variant="contained" className="mt-8 normal-case">
          Back to home
        </Button>
      </div>
    </section>
  );
}
